import heartListingImage from '../../../assets/effects/listing/Heart-listing.png';
import snowflakeListingImage from '../../../assets/effects/listing/Snowflake-listing.png';

export const SUNLIGHT_EFFECT_TYPE = 'Sunlight';
export const LEGACY_LIGHTING_EFFECT_TYPE = 'Lighting';

const encodeSvgPreview = (svg: string) =>
  `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;

export const SUNLIGHT_EFFECT_PREVIEW = encodeSvgPreview(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 160">
  <defs>
    <radialGradient id="glow" cx="70%" cy="24%" r="72%">
      <stop offset="0" stop-color="#fff9d5" stop-opacity="1"/>
      <stop offset="0.25" stop-color="#ffe78a" stop-opacity="0.92"/>
      <stop offset="0.62" stop-color="#ffb84f" stop-opacity="0.24"/>
      <stop offset="1" stop-color="#10131d" stop-opacity="0"/>
    </radialGradient>
    <linearGradient id="beam" x1="0.72" y1="0.02" x2="0.12" y2="1">
      <stop offset="0" stop-color="#fff6bd" stop-opacity="0.86"/>
      <stop offset="0.52" stop-color="#ffd66d" stop-opacity="0.26"/>
      <stop offset="1" stop-color="#ffb64d" stop-opacity="0"/>
    </linearGradient>
  </defs>
  <rect width="240" height="160" rx="16" fill="#11141e"/>
  <path d="M160 0 36 160h54L185 0z" fill="url(#beam)" opacity="0.9"/>
  <path d="M198 0 102 160h40L224 0z" fill="url(#beam)" opacity="0.62"/>
  <circle cx="172" cy="36" r="104" fill="url(#glow)"/>
  <circle cx="174" cy="30" r="18" fill="#fffbe3"/>
  <path d="M68 45h8l3-18 3 18h8l-7 5 3 18-7-11-7 11 3-18z" fill="#fff1a8" opacity="0.92"/>
  <circle cx="114" cy="91" r="5" fill="#fff7c7" opacity="0.88"/>
  <circle cx="202" cy="104" r="3" fill="#ffe39a" opacity="0.72"/>
</svg>
`);

const effectListingImages: Record<string, string> = {
  Heart: heartListingImage,
  [LEGACY_LIGHTING_EFFECT_TYPE]: SUNLIGHT_EFFECT_PREVIEW,
  [SUNLIGHT_EFFECT_TYPE]: SUNLIGHT_EFFECT_PREVIEW,
  Snowflake: snowflakeListingImage,
};

export const getEffectListingImage = (
  effectType: string
): string | undefined => effectListingImages[effectType];

export const getEffectDisplayName = (effectType: string): string =>
  effectType === LEGACY_LIGHTING_EFFECT_TYPE ? SUNLIGHT_EFFECT_TYPE : effectType;

export const isSunlightEffect = (effectType?: string): boolean =>
  effectType === SUNLIGHT_EFFECT_TYPE ||
  effectType === LEGACY_LIGHTING_EFFECT_TYPE;

export const getEffectTypeFromImagePath = (imagePath: string): string => {
  const fileName = imagePath.split('/').pop()?.split('?')[0] ?? '';
  const fileBaseName = fileName.split('.')[0] ?? '';
  const [effectName] = fileBaseName.split('-');

  return effectName;
};
